import React from "react";
import { Container, Card, CardBody, Row, Col, Media, Label, FormGroup } from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumb from "../../components/Common/Breadcrumb";
import img1 from "../../assets/images/companies/iicc-logo-new.png";
import img2 from "../../assets/images/companies/sobha.png";
import LKPhoneImg from "../../assets/images/LK_Icons/LK__Phone.svg";
import LKUserImg from "../../assets/images/LK_Icons/LK__User.svg";
import LKChargerImg from "../../assets/images/LK__EV charger_blue.svg";
import { connect } from "react-redux";
import { loadHost } from "../../api/utils/loadHost";
import { useState } from "react";
import { useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import Spinner from "../Utility/Spinner";
import LKRadioBtnCheck from "../../assets/images/LK_Icons/LK__Radio Button Check.svg";
import LKRadioBtnUnCheck from "../../assets/images/LK_Icons/LK__Radio Button Uncheck.svg";
import Cookies from "js-cookie";
import { hostSelected } from "../../store/hostTech/actions";
const Host = (props) => {
  const {hostSelected} = props
  const breadcrumbItems = [
    { title: "Charger Management System", link: "#" },
    { title: "Host", link: "#" },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [hostDetails, setHostDetails] = useState([]);
  const [viewAs, setViewAs] = useState("card");

  // on component mount load the host details
  useEffect(() => {
    handleLoadHost();
  }, []);
  // set cookie
  useEffect(() => {
    const cookieView = Cookies.get("view");
    if (!cookieView) {
      Cookies.set("view", "card", { expires: 90 });
    }
    setViewAs(Cookies.get("view"));
  }, []);

  // update cookies on dropdown selection
  useEffect(() => {
    Cookies.set("view", viewAs, { expires: 90 });
  }, [viewAs]);
  const handleLoadHost = async () => {
    try {
      setIsLoading(true);
      const data = await loadHost(props?.hostIds);
      const hostData = data?.map((item, index) => {
        const { name, email, phoneNumber, role, type, noOfCharger, noOfTrans } = item;
        return {
          slno: index + 1,
          name: name,
          email: email,
          phoneNumber: phoneNumber,
          role: role,
          type: type,
          noOfCharger: noOfCharger,
          noOfTrans: noOfTrans,
        };
      });
      setHostDetails(hostData);
    } catch (e) {
      console.log("Error Images Data: ", e);
    } finally {
      setIsLoading(false);
    }
  };

  const tableData = {
    columns: [
      { label: "Sl No.", field: "slno", sort: "asc", width: 20 },
      { label: "Name", field: "name", sort: "asc", width: 20 },
      { label: "Email", field: "email", sort: "asc", width: 20 },
      { label: "Phone Number", field: "phoneNumber", sort: "asc", width: 20 },
      { label: "Role", field: "role", sort: "asc", width: 20 },
      { label: "Type", field: "type", sort: "asc", width: 20 },
      { label: "No of Chargers", field: "noOfCharger", sort: "asc", width: 20 },
      { label: "No of Session", field: "noOfTrans", sort: "asc", width: 20 },
    ],
    rows: hostDetails,
  };
  const handleHostClick = (email) => {
    hostSelected(email);
    props.history.push("/cms-add-host")
    // props?.history?.push("/cms-add-host")
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="host" breadcrumbItems={breadcrumbItems} />
          {/* <Card>
            View Layout
          </Card> */}
          {/* select layout */}
          <Card className="p-3 ">
            <FormGroup style={styles.viewAs}>
              <Label className="font-weight-medium font-family-secondary mt-1">View Layout:</Label>
              {
                <div style={{ display: "flex", gap: "10px" }}>
                  {["card", "list"].map((opt) => (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", cursor: "pointer" }} key={opt}>
                      <label>
                        <img
                          alt={viewAs === "card" ? "checked Img" : "unchecked Img"}
                          src={viewAs === opt ? LKRadioBtnCheck : LKRadioBtnUnCheck}
                          style={{ width: "20px", height: "20px", cursor: "pointer" }}
                          onClick={() => setViewAs(opt)}
                        />
                      </label>
                      <span onClick={() => setViewAs(opt)} style={{ fontSize: "16px", marginBottom: "8px" }}>
                        {opt}
                      </span>
                    </div>
                  ))}
                </div>
              }

              {/* <CustomInput type="radio" id="card" name="viewAs" value="card" label="Card View" checked={viewAs === "card"} onChange={() => setViewAs("card")} />
                      <CustomInput type="radio" id="list" name="viewAs" value="list" label="List View" checked={viewAs === "list"} onChange={() => setViewAs("list")} /> */}
            </FormGroup>
          </Card>
          <Row>
            {isLoading ? (
              <Col className=" d-flex align-items-center justify-content-center" style={styles.loaderContainer}>
                <Spinner />
              </Col>
            ) : viewAs === "card" ? (
              hostDetails?.map((shop, key) => (
                <Col xl={3} sm={6} key={key}>
                  <Card>
                    <CardBody>
                      <div
                        // to={"/cms-add-host"}
                        style={{cursor:"pointer"}}
                        className="text-dark"
                        onClick={() => {
                          handleHostClick(shop?.email);
                        }}
                      >
                        <div className="text-center">
                          <Media body>
                            <div className="d-flex flex-column mb-1">
                              <div className="d-flex align-items-start mb-2">
                                <span className="d-flex align-items-center" style={{ minWidth: "55px" }}>
                                  {/* <img src={LKUserImg} alt="LKTransactionImg" style={styles.imgStyle} /> */}
                                  <b>Name</b>
                                </span>
                                <b style={styles.colonStyle}>:</b>
                                <span style={styles.valueStyle}>{shop.name}</span>
                              </div>
                              <div className="d-flex align-items-start mb-2">
                                <span className="d-flex " style={{ minWidth: "55px" }}>
                                  {/* <img src={LKPhoneImg} alt="LKTimerImg" style={styles.imgStyle} /> */}
                                  <b>Contact</b>
                                </span>
                                <b style={styles.colonStyle}>:</b>
                                <span style={styles.valueStyle}> {shop.phoneNumber}</span>
                              </div>
                              <div className="d-flex align-items-start mb-2">
                                <span className="d-flex " style={{ minWidth: "55px" }}>
                                  {/* <img src={LKMailImg} alt="LKSavingImg" style={styles.imgStyle} /> */}
                                  <b>Email</b>
                                </span>
                                <b style={styles.colonStyle}>:</b>
                                <span style={{ ...styles.valueStyle }}> {shop.email}</span>
                              </div>
                            </div>
                          </Media>
                        </div>
                      </div>

                      <hr className="my-2" />

                      <Row className="text-center">
                        <Col xs={6} className="d-flex flex-column align-items-center">
                          <div className="d-flex align-items-center">
                            <img src={LKChargerImg} alt="LKSavingImg" style={styles.imgStyle} />
                            <i className=""></i>
                            <span className="text-muted ">Chargers</span>
                          </div>

                          <h5>{shop?.noOfCharger}</h5>
                        </Col>
                        <Col xs={6} className="d-flex flex-column align-items-center">
                          <div className="d-flex align-items-center">
                            {/* <img src={LKChargerImg} alt="LKSavingImg" style={styles.imgStyle} /> */}
                            <i className="ri-stack-line mr-2" style={{ fontSize: "16px", color: "#005C8E" }}></i>
                            <span className="text-muted ">Session</span>
                          </div>

                          <h5>{shop?.noOfTrans}</h5>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              ))
            ) : (
              <Col lg={12}>
                <Card className="p-3">
                  <MDBDataTable hover responsive data={tableData} />
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const styles = {
  colonStyle: { width: "10px", textAlign: "center" },
  valueStyle: { marginLeft: "5px" },
  imgStyle: { width: "16px", height: "16px", marginRight: "5px" },
  loaderContainer: { height: "290px" },
  viewAs: { display: "flex", gap: "15px", marginTop: "4px", marginBottom: "0px" },
};
const mapStateToProps = (state) => ({
  hostIds: state?.HostTechManagement?.hostIds,
});
const mapDispatchToProps = (dispatch) => ({
  hostSelected: (payload) => dispatch(hostSelected(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Host);
